var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.84,16.65,11.65,50,30.84,83.35H69.16L88.35,50,69.16,16.65H30.84M27,10H73L96,50,73,90H27L4,50Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_444",
    "data-name": "Path 444"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.89,61.49h-.26c-8.69-.14-16-7.8-16-16.85V34.1a6.6,6.6,0,0,1,6.59-6.59H59.4A6.6,6.6,0,0,1,66,34.1V44.63c0,9-7.3,16.71-16,16.85ZM40.23,33.64a.46.46,0,0,0-.45.46V44.63c0,5.69,4.68,10.68,10,10.72s10-5,10-10.72V34.1a.46.46,0,0,0-.45-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_445",
    "data-name": "Path 445"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.31,73.47H42.18a3.07,3.07,0,1,1,0-6.13H57.31a3.07,3.07,0,1,1,0,6.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_345",
    "data-name": "Line 345"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.75,73.47a3.06,3.06,0,0,1-3.07-3.06v-12a3.07,3.07,0,1,1,6.13,0v12A3.06,3.06,0,0,1,49.75,73.47Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillPoints);
export default __webpack_public_path__ + "static/media/SkillPoints.bff1cdc1390a198f1a2c1288324112ab.svg";
export { ForwardRef as ReactComponent };